// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LkP_","questions":"styles_questions__w7_R8","footer":"styles_footer__3-XF5"};